<template>
    <div class="steps">
        <ul class="steps-container">
            <li style="width:20%;" class="step-one">
                <div class="step">
                    <div class="step-image"><span></span></div>
                   
                    <div class="step-description">+{{returnCount}}</div>
                </div>
            </li>
            <li style="width:20%;" class="step-two">
                <div class="step">
                    
                    <div class="step-image"><span></span></div>
                  
                    <div class="step-description">+{{returnCount}}</div>
                </div>
            </li>
            <li style="width:20%;" class="step-three">
                <div class="step">
                    
                    <div class="step-image"><span></span></div>
               
                    <div class="step-description">+{{returnCount}}</div>
                </div>
            </li>
            <li style="width:20%;" class="step-four">
                <div class="step">
                   
                    <div class="step-image"><span></span></div>
                   
                    <div class="step-description">+{{returnCount}}</div>
                </div>
            </li>
            <li style="width:20%;" class="step-five">
                <div class="step">
                   
                    <div class="step-image"><span></span></div>
                   
                    <div class="step-description">+{{returnCount}}</div>
                </div>
            </li>
        </ul>
        <div class="step-bar" :style="{ width: progress + '%' }"></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
        progress: 4,
        tierPoints: 3
    };
  },
  computed: {
      returnUser () {
            return this.$store.getters.currentUser
       },
       returnCount() {
            return this.$store.getters.getCount
       },
        referralCount () {
            return this.$store.state.referrals.user.referralCount
        },
  },
  created(){

  },
  methods: {
       ...mapActions(['countCheck']),
        progressBar(){
          if(this.referralCount >= 1){
             document.querySelector(".step-one").classList.add('activated');
             this.progress = 14;
          }
          if(this.referralCount >= 2){
             document.querySelector(".step-two").classList.add('activated');
             this.progress = 32;
          }
           if(this.referralCount >= 3){
             document.querySelector(".step-three").classList.add('activated');
             this.progress = 51;
          }
           if(this.referralCount >= 4){
             document.querySelector(".step-four").classList.add('activated');
             this.progress = 70;
            }
            if(this.referralCount >= 5){
             document.querySelector(".step-five").classList.add('activated');
             this.progress = 101;
          }

        //   switch (this.$store.state.referrals.user.pledgeTier) {
        //     case "Tinkerer":
        //         this.tierPoints = 3;
        //         this.countCheck(3);
        //         break;
        //     case "Digital Tinkerer":
        //         this.tierPoints = 5;
        //         this.countCheck(5);
        //         break;
        //     case "Bug Hunter":
        //         this.tierPoints = 8;
        //         this.countCheck(8);
        //         break;
        //     case "Apprentice":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     case "Artificer":
        //         this.tierPoints = 12;
        //          this.countCheck(12);
        //         break;
        //     case "Elite Artificer":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     case "Warsmith":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     case "Elite Warsmith":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     case "Heroic Warsmith":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     case "Legendary Warsmith":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     case "Warsmith General":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     case "Warsmith Supreme":
        //         this.tierPoints = 12;
        //         this.countCheck(12);
        //         break;
        //     default:
        //         this.tierPoints = 3;
        //         this.countCheck(3);
        //         break;
        //     }
      }
  },
mounted(){
    var self = this;
    var progInterval = setInterval(function(){ self.progressBar() });
    setTimeout(function(){ clearInterval(progInterval); }, 10000);
    //clearInterval(progInterval);
  }
};
</script>


<style scoped>
.steps {
      min-height: 200px;
    margin-top: 60px;
    padding: 30px 0 0 0;
    font-family: 'Open Sans', sans-serif;
    position: relative;
    width: 100%;
    max-width: 1220px;
}

.steps .steps-container {
    background: #DDD;
    height: 18px;
    width: 100%;
    border-radius: 10px ;
    -moz-border-radius: 10px ;
    -webkit-border-radius: 10px ;
    -ms-border-radius: 10px ;
    margin: 0;
    list-style: none
}

.steps .steps-container li {
    text-align: center;
    list-style: none;
    float: left
}

.steps .steps-container li .step {
    padding: 0 50px
}

.steps .steps-container li .step .step-image {
    margin: -14px 0 0 0
}

.steps .steps-container li .step .step-image span {
    background-color: #DDD;
    display: block;
    width: 45px;
    height: 45px;
    margin: 0 auto;
    border-radius: 37px ;
    -moz-border-radius: 37px ;
    -webkit-border-radius: 37px ;
    -ms-border-radius: 37px
}

.steps .steps-container li .step .step-current {
    font-size: 11px;
    font-style: italic;
    color: #999;
    margin: 8px 0 0 0
}

.steps .steps-container li .step .step-description {
    font-size: 19px;
    color: #3d5671;
    position: relative;
    font-weight: 700;
    top: -39px;
    z-index: 1;
}

.steps .steps-container li.activated .step .step-image span {
    background-color: #5DC177
}

.steps .steps-container li.activated .step .step-image span:after {
    background-color: #FFF;
    display: block;
    content: '';
    position: absolute;
    z-index: 1;
    width: 34px;
    height: 34px;
    margin: 5px;
    border-radius: 27px ;
    -moz-border-radius: 27px ;
    -webkit-border-radius: 27px ;
    -ms-border-radius: 27px ;
    box-shadow: 4px 4px 0px 0px rgba(0,0,0,0.15) ;
    -moz-box-shadow: 4px 4px 0px 0px rgba(0,0,0,0.15) ;
    -webkit-box-shadow: 4px 4px 0px 0px rgba(0,0,0,0.15)
}

.steps .step-bar {
    background-color: #5DC177;
    height: 18px;
    position: absolute;
    top: 30px;
    border-radius: 10px 10px 10px 10px;
}

.steps .step-bar.last {
    border-radius: 10px ;
    -moz-border-radius: 10px ;
    -webkit-border-radius: 10px ;
    -ms-border-radius: 10px
}
@media only screen and (max-width: 705px) {
    .steps .steps-container li .step {
        padding: 0 0px;
    }
    .steps .steps-container li .step .step-image {
        margin: -14px 0 0 0;
    }
    .steps .steps-container {
        padding-inline-start: 10px;
    }
    .step-current {
        display: none;
    }
    .steps {
        margin-top: 24px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/progressBar.vue